document.addEventListener("DOMContentLoaded", function () {
    const content = document.querySelector(".hero-content");
    const beadcrumb = document.querySelector(".breadcrumbs-container");
    let contentHeight = content.offsetHeight;
    let beadcrumbHeight = beadcrumb.offsetHeight;
    let topPosition = -(beadcrumbHeight / 2);

    if (window.innerWidth < 992) {
        setHeight();
    }

    
    window.addEventListener("resize", function (e) {
      if (e.target.innerWidth < 992) {
        setHeight();
      } else {
        resetHeight();
      }
    });

    function setHeight() {
        contentHeight = content.offsetHeight;
        beadcrumbHeight = beadcrumb.offsetHeight;
        topPosition = -(beadcrumbHeight / 2);

        content.style.top = topPosition + "px";
        content.style.position = "relative";
        content.style.justifyContent = "center";
    }

    function resetHeight() {
      content.style.top = null;
      content.style.position = null;
      content.style.justifyContent = null;
    }
});


